import React from "react";
import PropTypes from "prop-types";
import { classes, colors } from "@mqd/volt-toolbox/src";
export const ELEMENT_MAP = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  body: "p",
  "body--sm": "p",
  "body--lg": "p",
  label: "label",
  footnote: "p",
  code: "code",
  pre: "pre"
};
export function Text({
  as,
  children,
  className,
  color,
  mod,
  testId,
  type,
  ...textProps
}) {
  mod = type || mod;
  color = colors[color] || color;
  const Component = as || ELEMENT_MAP[mod];
  const style = {};
  if (color) {
    style.color = color;
  }
  return /* @__PURE__ */ React.createElement(
    Component,
    {
      className: classes("text", `text__${mod}`, className),
      "data-testid": testId,
      style,
      ...textProps
    },
    children
  );
}
const MODS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "body",
  "body--sm",
  "body--lg",
  "label",
  "footnote",
  "code",
  "pre"
];
Text.propTypes = {
  as: PropTypes.oneOf([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p",
    "span",
    "label",
    "div",
    "pre",
    "code"
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  testId: PropTypes.string,
  mod: PropTypes.oneOf(MODS),
  type: PropTypes.oneOf(MODS)
};
Text.defaultProps = {
  mod: "body"
};
